// Centralized option lists for business and location preference forms.
// Keep values aligned with backend-accepted preference payloads.

export const TIMEZONE_OPTIONS = [
    { value: 'America/Halifax', label: 'Atlantic Time (Halifax)' },
    { value: 'America/Chicago', label: 'Central Time (Chicago)' },
    { value: 'America/Toronto', label: 'Eastern Time (Toronto)' },
    { value: 'America/Denver', label: 'Mountain Time (Denver)' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (Los Angeles)' },
    { value: 'America/New_York', label: 'Eastern Time (New York)' }
];

export const COUNTRY_OPTIONS = [
    { value: 'Canada', label: 'Canada' },
    { value: 'USA', label: 'United States' }
];

const COUNTRY_ID_BY_NAME = {
    Canada: 1,
    USA: 2,
    'United States': 2,
    US: 2
};

export const normalizeCountryValue = (value) => {
    if (!value) {
        return 'Canada';
    }

    if (value === 'United States' || value === 'US') {
        return 'USA';
    }

    return value;
};

export const getCountryId = (countryValue) => {
    const normalized = normalizeCountryValue(countryValue);
    return COUNTRY_ID_BY_NAME[normalized] || 1;
};

export const CURRENCY_OPTIONS = [
    { value: 'CAD', label: 'CAD ($)' },
    { value: 'USD', label: 'USD ($)' },
    { value: 'EUR', label: 'EUR (€)' },
    { value: 'GBP', label: 'GBP (£)' }
];

export const DATE_FORMAT_OPTIONS = [
    { value: 'YYYY-MM-DD', label: 'YYYY-MM-DD (2025-01-31)' },
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY (01/31/2025)' },
    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY (31/01/2025)' },
    { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY (31-01-2025)' }
];

export const TIME_FORMAT_OPTIONS = [
    { value: '12', label: '12-hour (2:30 PM)' },
    { value: '24', label: '24-hour (14:30)' }
];

export const POSTAL_CODE_FORMATS = [
    { value: 'A1A 1A1', label: 'A1A 1A1 (Canadian)' },
    { value: '12345', label: '12345 (US ZIP)' },
    { value: '12345-6789', label: '12345-6789 (US ZIP+4)' }
];

export const INVOICE_FORMAT_OPTIONS = [
    { value: '{TYPE}-{STORE}-{YYYY}-{#######}', label: 'INV-A-2025-0000001 / Q-A-2025-0000001 (Recommended)' },
    { value: '{STORE}-{TYPE}-{YYYY}-{#######}', label: 'A-INV-2025-0000001 / A-Q-2025-0000001 (Store First)' },
    { value: '{TYPE}{STORE}{YYYY}{#######}', label: 'INVA20250000001 / QA20250000001 (Compact)' },
    { value: 'custom', label: 'Custom Format...' }
];

export const detectSystemTimezone = (options = TIMEZONE_OPTIONS) => {
    try {
        const detectedTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const exactMatch = options.find((opt) => opt.value === detectedTz);

        if (exactMatch) {
            return { value: detectedTz, label: exactMatch.label };
        }

        const region = (detectedTz || '').split('/')[0];
        const regionMatch = options.find((opt) => opt.value.includes(region));
        if (regionMatch) {
            return { value: regionMatch.value, label: regionMatch.label };
        }

        return options[0] || null;
    } catch (e) {
        return null;
    }
};

export const getTimezoneLabel = (timezone) => {
    const option = TIMEZONE_OPTIONS.find((tz) => tz.value === timezone);
    return option ? option.label : timezone;
};
